import { jsx as _jsx, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { SectionContainer } from "./SectionRows.styles";
export var SectionRows = function(param) {
    var children = param.children, sections = param.sections;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: sections.map(function(section) {
            return /*#__PURE__*/ _jsx(SectionContainer, {
                children: children(section)
            }, section.position);
        })
    });
};
